export default __webpack_public_path__ + "static/media/about-us-3.3c82ae2f.webp";